(function () {
  function getPopup() {
    return document.getElementById('CountryPopup');
  }

  function syncDefaults(popup) {
    popup.querySelectorAll('select[data-current]').forEach(function (sel) {
      var current = sel.getAttribute('data-current');
      if (current && sel.value !== current) sel.value = current;
    });
  }

  function openPopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.hidden = false;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('country-popup-open');
    syncDefaults(popup);
    var firstSelect = popup.querySelector('select');
    if (firstSelect) firstSelect.focus({ preventScroll: true });
  }

  function closePopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    popup.hidden = true;
    document.body.classList.remove('country-popup-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-country-popup-open]')) {
      event.preventDefault();
      openPopup();
      return;
    }
    if (event.target.closest('[data-country-popup-close]')) {
      event.preventDefault();
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var popup = getPopup();
      if (popup && popup.classList.contains('is-open')) closePopup();
    }
  });
})();
